/*
 *  -----------------------------------------------------------------------
 *    <copyright file="update-users-array.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { formUpdatedCreatedField } from '@utils/filter';

// Mutate existing array with adding two new fields
export const restructuredUpdatedCreatedBy = (items: unknown[]): unknown[] => {
    if (items) {
        /* eslint-disable @typescript-eslint/no-explicit-any */
        return items.map((item: any) => ({
            ...item,
            _createdByString: formUpdatedCreatedField(item.createdBy ?? item.createdByName),
            _updatedByString: formUpdatedCreatedField(item.updatedBy ?? item.updatedByName),
        }));
    }

    return [];
};
